export const MEDLINE_PLUS_URL =
  'https://connect.medlineplus.gov/application?mainSearchCriteria.v.dn=';
